import { Box } from '@wix/design-system';
import _ from 'lodash';
import { FC, useMemo } from 'react';
import Project from '../Project';
import { PortfolioItemWithUrl } from '../Project/Project';
import s from './ProjectGrid.module.scss';

const STANDARD_ROW_PROJECT_COUNT = 3;
const SECOND_ROW_PROJECT_COUNT = 2;

const ROW_PATTERN = [
  STANDARD_ROW_PROJECT_COUNT,
  SECOND_ROW_PROJECT_COUNT,
  STANDARD_ROW_PROJECT_COUNT,
];

type Props = {
  projects: PortfolioItemWithUrl[];
  quantityToDisplay: number;
  isMobileView?: boolean;
};

const ProjectGrid: FC<Props> = ({
  projects,
  quantityToDisplay,
  isMobileView,
}) => {
  const rows = useMemo(() => {
    if (isMobileView) return [];

    const projectsToShow = projects.slice(0, quantityToDisplay);
    const computedRows: PortfolioItemWithUrl[][] = [];

    let currentIndex = 0;
    let patternIndex = 0;

    while (currentIndex < projectsToShow.length) {
      // Use pattern for first 3 rows, then default to standard size
      const rowSize =
        patternIndex < ROW_PATTERN.length
          ? ROW_PATTERN[patternIndex]
          : STANDARD_ROW_PROJECT_COUNT;

      const endIndex = Math.min(currentIndex + rowSize, projectsToShow.length);
      computedRows.push(projectsToShow.slice(currentIndex, endIndex));

      currentIndex = endIndex;
      patternIndex++;
    }

    return computedRows;
  }, [projects, quantityToDisplay, isMobileView]);

  if (isMobileView) {
    return (
      <div className={s.projectsMobile}>
        {_.map(projects, (portfolioItem) => (
          <Project
            {...portfolioItem}
            key={portfolioItem.metaSiteId}
            isMobileView={isMobileView}
          />
        ))}
      </div>
    );
  }

  return (
    <Box className={s.projectGrid} direction="vertical">
      {rows.map((row, rowIndex) => (
        <Box
          key={rowIndex}
          className={`${s.projectRow} ${
            rowIndex === 1 ? s.twoProjectRow : s.threeProjectRow
          }`}
          direction="horizontal"
        >
          {row.map((portfolioItem) => (
            <Box key={portfolioItem.metaSiteId} className={s.projectRowItem}>
              <Project
                {...portfolioItem}
                key={portfolioItem.metaSiteId}
                isMobileView={isMobileView}
              />
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default ProjectGrid;
